import { render, staticRenderFns } from "./ChangePhone.vue?vue&type=template&id=4e4c1b25"
import script from "./ChangePhone.vue?vue&type=script&lang=js"
export * from "./ChangePhone.vue?vue&type=script&lang=js"
import style0 from "./ChangePhone.vue?vue&type=style&index=0&id=4e4c1b25&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports